import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static values = {
    options: Array,
    disableSearch: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
  };

  connect () {
    if (!this.element.tomselect) {
      const ts = new TomSelect(this.element, this._settingsFactory(this.element));

      if (this.placeholderValue && this.disableSearchValue) {
        this._addCustomPlaceholder(ts);
      }
    }
  }

  _addCustomPlaceholder (ts) {
    const el = document.createElement('span');
    el.className = 'ts-custom-placeholder';
    el.textContent = this.placeholderValue;
    el.style.cssText = 'color: #adb5bd; pointer-events: none;';
    ts.control.prepend(el);

    const toggle = () => {
      el.style.display = (ts.items.length > 0 && ts.items[0] !== '') ? 'none' : '';
    };

    ts.on('change', toggle);
    toggle();
  }

  disconnect () {
    const value = this.element.value;

    this.element.tomselect.destroy();

    // necessary to persist value because
    // this.element.tomselect.destroy() sets the value to null
    this.element.value = value;
  }

  _settingsFactory (element) {
    const ajaxUrl = element.dataset.ajaxUrl;
    const ajaxTextField = element.dataset.ajaxTextField;
    const ajaxValueField = element.dataset.ajaxValueField;
    const ajaxMatcher = element.dataset.ajaxSearchMatcher;
    const ajaxDisplayedField = (
      element.dataset.ajaxDisplayedField ? element.dataset.ajaxDisplayedField : ajaxTextField
    );
    const ajaxAdditionalFilters = (
      element.dataset.ajaxAdditionalFilters
        ? JSON.parse(element.dataset.ajaxAdditionalFilters)
        : []
    );

    const additionalFiltersQuery = ajaxAdditionalFilters.reduce((acc, filter) => {
      return acc + `&q[${filter[0]}]=${filter[1]}`;
    }, '');

    const formatAjaxData = (json, valueField, textField) => {
      return json.map(entry => (
        {
          value: entry[valueField],
          text: entry[textField]
        }
      ));
    };

    const settingsStore = {
      create: {
        create: input => ({ value: input, text: input }),
        persist: false
      },
      ajax: {
        valueField: 'value',
        labelField: 'text',
        searchField: 'text',
        score: function () {
          return function () { return 1; };
        },
        load: function (query, callback) {
          const searchParam = `q[${ajaxTextField}_${ajaxMatcher}]`;
          const url = `${ajaxUrl}?${searchParam}=${encodeURIComponent(query)}${additionalFiltersQuery}`;
          fetch(url, {
            headers: {
              Accept: 'application/json'
            }
          })
            .then(response => response.json())
            .then(json => {
              this.clearOptions();
              callback(formatAjaxData(json, ajaxValueField, ajaxDisplayedField));
            }).catch((e) => {
              callback();
            });
        }
      }
    };

    const settings = {
      placeholder: this.placeholderValue,
      maxOptions: null,
      onItemAdd: function () {
        this.setTextboxValue('');
      },
      plugins: {},
    };

    if (element.multiple) {
      settings.plugins.remove_button = { title: 'remove' };
    }

    if (this.disableSearchValue) {
      settings.controlInput = null;
      settings.closeAfterSelect = true;
      settings.onItemAdd = function () {
        this.setTextboxValue('');
        this.blur();
      };
    }

    if (this.hasOptionsValue) { Object.assign(settings, settings, {options: this.optionsValue}); }
    if (element.classList.contains('tom-select-ajax')) { Object.assign(settings, settings, settingsStore.ajax); }
    if (element.classList.contains('tom-select-create')) { Object.assign(settings, settings, settingsStore.create); }

    return settings;
  }
}
